// START: GitHub Copilot Generated Code
import store from "../reduxToolkit/store";
import { isSupportedLanguage } from "./languageUtils";

export { isSupportedLanguage };

/**
 * Returns the current language from the Redux store, falling back to the
 * configured default language. Use this instead of accessing the store
 * directly so there is a single point of change if the selector ever moves.
 */
export const getCurrentLanguage = (): string =>
  store.getState().language.language;

/**
 * Checks if a language is supported by the application
 * OWASP Security: Validates language against allowed list
 * isSupportedLanguage is re-exported from languageUtils.ts (above) to avoid
 * a circular dependency through store.ts.
 */

/**
 * Initialize preferred language for a logged-in user
 * Fetches user's language preference from API and updates Redux
 * 
 * @param userId - The user's ID
 */
export const initializePreferredLanguage = async (userId?: string): Promise<void> => {
  if (userId) {
    // TODO: Call API to get user preference
    // TODO: Dispatch updateLanguage action with the fetched language
    // TODO: Trigger any language side-effects if needed
  }
};
// END: GitHub Copilot Generated Code
